import { render, staticRenderFns } from "./stock-board.vue?vue&type=template&id=097cdf52&scoped=true&"
import script from "./stock-board.vue?vue&type=script&lang=js&"
export * from "./stock-board.vue?vue&type=script&lang=js&"
import style0 from "./stock-board.vue?vue&type=style&index=0&id=097cdf52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097cdf52",
  null
  
)

export default component.exports